import { HttpParams } from '@angular/common/http';
import { SentEmailLogGetQueryParamsInterface } from './definitions/sent-email-log-get-query-params.interface';

export function createQueryParams(paramsObj: SentEmailLogGetQueryParamsInterface): HttpParams {
  let params: HttpParams = new HttpParams();

  params = params.set('page', paramsObj.Page.toString());

  params = params.set('pageSize', paramsObj.PageSize.toString());

  if (paramsObj.Status !== null) {
    params = params.set('status', paramsObj.Status);
  }

  return params;
}